import React from 'react';
import AppFilterSelect from './AppFilterSelect';

/**
 * Select commercial unifié (même UX que le chiffrage site).
 * - multiple=false (défaut) : une seule valeur, searchable, vidable, « — »
 * - multiple=true : plusieurs commerciaux (plannings ventes)
 *
 * value: string[] ; onChange: (next: string[]) => void
 */
export default function AppFilterCommercialSelect({
  id,
  value = [],
  onChange,
  options = [],
  label = 'Commercial',
  col = 'col-6 col-md-3 col-lg-2',
  disabled = false,
  placeholder = '—',
  emptyLabel = 'Aucun commercial',
  className = '',
  multiple = false,
}) {
  const selected = Array.isArray(value)
    ? value.map((item) => String(item ?? '').trim()).filter(Boolean)
    : (value ? [String(value)] : []);
  const normalizedSelected = multiple ? selected : selected.slice(-1);

  return (
    <AppFilterSelect
      id={id}
      label={label}
      col={col}
      value={normalizedSelected}
      onChange={(next) => {
        const normalized = Array.isArray(next)
          ? next.map((item) => String(item ?? '').trim()).filter(Boolean)
          : [];
        onChange(multiple ? normalized : normalized.slice(-1));
      }}
      options={options}
      multiple={multiple}
      placeholder={placeholder}
      emptyLabel={emptyLabel}
      disabled={disabled}
      className={className}
    />
  );
}
